import React from "react";
import { Helmet } from "react-helmet";

/**
 * Left brand panel shared by SignIn / SignUp / recovery / confirm.
 */
export default function AuthBrand({ title, text }) {
  return (
    <div className="gx-app-logo-content">
      <div className="gx-app-logo-content-bg" aria-hidden="true" />
      <div className="gx-app-logo-wid">
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <h1>{title}</h1>
        {text ? <p>{text}</p> : null}
      </div>
      <a className="gx-app-logo" href="https://www.debt-master.ru/" target="_blank" rel="noopener noreferrer">
        <img src="/assets/images/logo-hero-white.svg" alt="debtmaster" width="200" height="40" />
      </a>
    </div>
  );
}
